import { LocaleCode } from 'src/app/interfaces/locale'
import { FeedCard } from 'src/app/interfaces/main'

export interface Feed {
  type: 'feed-card' | 'ask' | 'survey'
  data?: FeedCard
  needToInstallApp?: boolean
}

export const feedPaths: { [key in LocaleCode]: (Omit<Feed, 'data'> & { pathname: string })[] } = {
  ko: [
    { type: 'feed-card', pathname: '/egen-teto' },
    { type: 'feed-card', pathname: '/hsp' },
    { type: 'feed-card', pathname: '/saju' },
    { type: 'feed-card', pathname: '/soulmate' },
    { type: 'feed-card', pathname: '/soulmate/landing' },
    { type: 'feed-card', pathname: '/saju?type=day-pillar' },
    { type: 'feed-card', pathname: '/daily-log/landing' },
    { type: 'feed-card', pathname: '/quiz/create?v=1' },
    { type: 'feed-card', pathname: '/chat-analysis' },
    { type: 'feed-card', pathname: '/chat-analysis?type=situationship' },
    { type: 'feed-card', pathname: '/group-chemi/create' },
    { type: 'feed-card', pathname: '/daily-log/onboarding' },
    { type: 'feed-card', pathname: '/ideal-quiz/create' },
    { type: 'feed-card', pathname: '/log-quiz/landing' },
    { type: 'feed-card', pathname: '/ideal/create' },
    { type: 'feed-card', pathname: '/bf/create' },
    { type: 'feed-card', pathname: '/guess-me' },
    { type: 'survey', pathname: '' },
    { type: 'ask', pathname: '' },
    { type: 'feed-card', pathname: '/cabinet/landing' },
    { type: 'feed-card', pathname: '/attachment-test' },
    { type: 'feed-card', pathname: '/image-game' },
    { type: 'feed-card', pathname: '/fw/create?id=16' },
    { type: 'feed-card', pathname: '/fw/create?id=15' },
  ],
  en: [
    { type: 'feed-card', pathname: '/hsp', needToInstallApp: true },
    { type: 'feed-card', pathname: '/soulmate', needToInstallApp: true },
    { type: 'feed-card', pathname: '/quiz/create?v=1' },
    { type: 'feed-card', pathname: '/saju', needToInstallApp: true },
    { type: 'feed-card', pathname: '/chat-analysis', needToInstallApp: true },
    { type: 'feed-card', pathname: '/chat-analysis?type=situationship', needToInstallApp: true },
    { type: 'feed-card', pathname: '/chat-analysis?type=dating', needToInstallApp: true },
  ],
  ja: [
    { type: 'feed-card', pathname: '/hsp' },
    { type: 'feed-card', pathname: '/soulmate/landing' },
    { type: 'feed-card', pathname: '/quiz/create?v=1' },
    { type: 'feed-card', pathname: '/saju' },
    { type: 'feed-card', pathname: '/chat-analysis', needToInstallApp: true },
    { type: 'feed-card', pathname: '/chat-analysis?type=situationship', needToInstallApp: true },
    { type: 'feed-card', pathname: '/chat-analysis?type=dating', needToInstallApp: true },
  ],
  zhHant: [
    { type: 'feed-card', pathname: '/hsp', needToInstallApp: true },
    { type: 'feed-card', pathname: '/soulmate', needToInstallApp: true },
    { type: 'feed-card', pathname: '/quiz/create?v=1', needToInstallApp: true },
    { type: 'feed-card', pathname: '/saju', needToInstallApp: true },
    { type: 'feed-card', pathname: '/chat-analysis', needToInstallApp: true },
    { type: 'feed-card', pathname: '/chat-analysis?type=situationship', needToInstallApp: true },
    { type: 'feed-card', pathname: '/chat-analysis?type=dating', needToInstallApp: true },
  ],
}
